import { COUNTY_NAMES, PARTIES, PARTY_ORDER, type GlobalAggregate, type PartyId } from '../lib/types';

interface Props {
  aggregate: GlobalAggregate;
}

export function CountyControl({ aggregate }: Props) {
  const { countyDistricts, totals } = aggregate;
  if (!countyDistricts || Object.keys(countyDistricts).length === 0) return null;

  const fullyOwned = totals.fullyOwnedLansByParty ?? {};

  const counties = Object.entries(countyDistricts)
    .map(([code, partyMap]) => {
      const sorted = PARTY_ORDER
        .map(p => ({ p, c: partyMap[p] ?? 0 }))
        .filter(x => x.c > 0)
        .sort((a, b) => b.c - a.c);
      const total = sorted.reduce((s, x) => s + x.c, 0);
      const leader = sorted[0] ?? null;
      const fullyOwnedBy = (PARTY_ORDER.find(p => (fullyOwned[p] ?? []).includes(code)) ?? null) as PartyId | null;
      return { code, sorted, total, leader, fullyOwnedBy };
    })
    .filter(c => c.total > 0)
    .sort((a, b) => {
      if (a.fullyOwnedBy && !b.fullyOwnedBy) return -1;
      if (!a.fullyOwnedBy && b.fullyOwnedBy) return 1;
      return b.total - a.total;
    });

  return (
    <section className="county-control" id="lanen">
      <h2>Läget i länen</h2>
      <div className="county-list">
        {counties.map(({ code, sorted, total, leader, fullyOwnedBy }) => (
          <div className="county-row" key={code}>
            <div className="county-name-wrap">
              <span className="county-name">{COUNTY_NAMES[code] ?? code}</span>
              {fullyOwnedBy && (
                <span
                  className="county-badge"
                  style={{ color: PARTIES[fullyOwnedBy].color, borderColor: PARTIES[fullyOwnedBy].color }}
                >
                  Kontrollerat
                </span>
              )}
            </div>
            <div className="county-bar">
              {sorted.map(({ p, c }) => (
                <div
                  key={p}
                  className="county-bar-seg"
                  style={{ width: `${(c / total) * 100}%`, backgroundColor: PARTIES[p].color }}
                  title={`${PARTIES[p].name}: ${c}`}
                />
              ))}
            </div>
            {leader && (
              <div
                className="county-dot"
                style={{ backgroundColor: PARTIES[leader.p].color }}
                title={PARTIES[leader.p].name}
              />
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
